import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';

//declare function ire(string,{}): any;
@Component({
  selector: 'app-trinka-cloud',
  templateUrl: './trinka-cloud.component.html',
  styleUrls: ['./trinka-cloud.component.scss']
})
export class TrinkaCloudComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('どこにいてもらくらく英文ライティング | Trinka Cloud ');
    this.metaTagService.updateTag({ name: 'description', content: 'AI校正ツールTrinka Cloudで、外出先でも効果的な英文ライティングを。リアルタイムで原稿を修正、専門性の高い文書の作成をサポート。いつでもどこでも洗練された英作文が可能に。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '文法チェック 文法チェックツール.英文　校正　サイト.英文校正　無料,英文チェック　サイト,英文チェック　オンライン,英文校正　オンライン,スペルチェック　オンライン,スペルチェック　サイト,テクニカルライティング,アカデミックライティング,英文チェッカー,校正ツール,AI校正ツール,AIツール,学術論文,文法チェック,文法チェックツール,英文　校正　サイト,英文校正　無料,Trinka,トリンカ' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'どこにいてもらくらく英文ライティング | Trinka Cloud ' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'AI校正ツールTrinka Cloudで、外出先でも効果的な英文ライティングを。リアルタイムで原稿を修正、専門性の高い文書の作成をサポート。いつでもどこでも洗練された英作文が可能に。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/trinkacloud' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/cloud_banner_img.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'どこにいてもらくらく英文ライティング | Trinka Cloud' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "AI校正ツールTrinka Cloudで、外出先でも効果的な英文ライティングを。リアルタイムで原稿を修正、専門性の高い文書の作成をサポート。いつでもどこでも洗練された英作文が可能に。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/cloud_banner_img.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinkacloud' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function () { });
      // $.getScript('../../../assets/js/particles.min.js', function(){});
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  

}
